import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { StyledInputLabel } from './Input.component';

export interface TextareaProps {
  label?: string;
  value?: string;
  onChange?: Function;
  disabled?: boolean;
  readonly?: boolean;
  maxLength?: number;
  showCounter?: boolean;
}

const StyledTextarea = styled.textarea.attrs<{ maxLength?: string }>(props => ({
  maxlength: props.maxLength,
}))`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  resize: none;
  border: none;
  width: 100%;
  min-height: 200px;
  outline: none;
  background: transparent;

  :hover {
    outline: none;
  }
`;
const StyledTextareaWrapperFocus = css`
  border-color: ${({ theme }) => theme.colors.BLUE.B400};
`;
export const StyledTextareaWrapper = styled.div<{
  isFocus: boolean;
  isDisabled: boolean;
  isReadOnly: boolean;
}>`
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  transition: border-color 0.3s;
  padding: 5px 10px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.BG};

  ${props => props.isFocus && StyledTextareaWrapperFocus};
  ${props => props.isDisabled && `opacity: 0.5; pointer-events: none;`};
`;
export const StyledTextareaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const StyledCharCounter = styled.div<{ isNearLimit: boolean }>`
  font-size: 12px;
  color: ${({ theme, isNearLimit }) =>
    isNearLimit ? theme.colors.ORANGE.O400 : theme.colors.LABEL};
  text-align: right;
  padding: 0 10px;
`;

const TextareaComponent = ({
  label,
  value = '',
  onChange,
  disabled = false,
  readonly = false,
  maxLength = 255,
  showCounter = false,
}: TextareaProps) => {
  const [isFocus, setFocus] = useState(false);

  const handleChange = (e: any) => {
    const { value } = e.target;
    onChange && onChange(value);
  };

  const charCount = value?.length || 0;
  const isNearLimit = charCount >= maxLength * 0.9;

  return (
    <StyledTextareaContainer>
      {label && <StyledInputLabel>{label}</StyledInputLabel>}
      <StyledTextareaWrapper
        isFocus={isFocus}
        isDisabled={disabled}
        isReadOnly={readonly}
      >
        <StyledTextarea
          value={value}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          onChange={handleChange}
          disabled={disabled}
          readOnly={readonly}
          maxLength={maxLength}
        />
      </StyledTextareaWrapper>
      {showCounter && (
        <StyledCharCounter isNearLimit={isNearLimit}>
          {charCount} / {maxLength}
        </StyledCharCounter>
      )}
    </StyledTextareaContainer>
  );
};

export default TextareaComponent;
